export default __webpack_public_path__ + "static/media/slide23.4503adb2.jpg";